var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-item",on:{"click":_vm.selectNews}},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.news.title)+" ")]),_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.date)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }